import { render, staticRenderFns } from "./AddServiceModal.vue?vue&type=template&id=eb0652e0&scoped=true&"
import script from "./AddServiceModal.vue?vue&type=script&lang=js&"
export * from "./AddServiceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0652e0",
  null
  
)

export default component.exports